import "./CloseAccount.css";

export default function CloseAccount() {
  return (
    <div className="settings-user-info-box">
      <h3>Chiudi il tuo account</h3>
      <div className="settings-close-box">
        <p>
          Per chiudere il tuo account, prima sposta eventuali siti rimanenti nel
          Cestino. Di seguito contatta il supporto Farmakom per chiedere
          l'effettiva cancellazione del tuo account.
        </p>
        <a className="button" href="mailto:hello@farmakom.it">
          CONTATTA
        </a>
      </div>
    </div>
  );
}
